// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3rFqu","list_wrapper":"list_wrapper__3uHu7","contributionWrapper":"contributionWrapper__2zJWL","wrapperItem":"wrapperItem__1juJT","DonorContribution":"DonorContribution__3x0XE","AllDonorContribution":"AllDonorContribution__2N7fV","allDonorContribution":"allDonorContribution__1Y8JI","contributionText":"contributionText__tWKKN"};


//////////////////
// WEBPACK FOOTER
// ./components/donor-contribution-chart/style.scss
// module id = 5rOV
// module chunks = 22